// Orari della sede UNASCA di Roma, in minuti dalla mezzanotte (ora di Roma)
type Fascia = [number, number];

const h = (ore: number, minuti = 0) => ore * 60 + minuti;

// Indice 0 = domenica, come Date.getDay()
export const FASCE_UFFICIO: Fascia[][] = [
  [],
  [[h(9), h(13)], [h(14, 30), h(18, 30)]],
  [[h(9), h(13)], [h(14, 30), h(18, 30)]],
  [[h(9), h(13)], [h(14, 30), h(18, 30)]],
  [[h(9), h(13)], [h(14, 30), h(18, 30)]],
  [[h(9), h(13)], [h(14), h(18)]],
  [],
];

const NOMI_GIORNI = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];
const GIORNI_EN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export interface StatoUfficio {
  aperto: boolean;
  testo: string;
}

const orario = (minuti: number) => `${Math.floor(minuti / 60)}:${String(minuti % 60).padStart(2, '0')}`;

// Giorno della settimana e minuti correnti nel fuso di Roma, qualunque sia il fuso del visitatore
export const momentoRoma = (data: Date): { giorno: number; minuti: number } => {
  const parti = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Europe/Rome',
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(data);
  const valore = (tipo: string) => parti.find((p) => p.type === tipo)?.value || '';
  return {
    giorno: GIORNI_EN.indexOf(valore('weekday')),
    minuti: Number(valore('hour')) * 60 + Number(valore('minute')),
  };
};

export const statoUfficio = (giorno: number, minuti: number): StatoUfficio => {
  const fasciaAttuale = FASCE_UFFICIO[giorno].find(([inizio, fine]) => minuti >= inizio && minuti < fine);
  if (fasciaAttuale) {
    return { aperto: true, testo: `Aperto ora, chiude alle ${orario(fasciaAttuale[1])}` };
  }
  const piuTardiOggi = FASCE_UFFICIO[giorno].find(([inizio]) => inizio > minuti);
  if (piuTardiOggi) {
    return { aperto: false, testo: `Chiuso, riapre oggi alle ${orario(piuTardiOggi[0])}` };
  }
  for (let scarto = 1; scarto <= 7; scarto++) {
    const g = (giorno + scarto) % 7;
    const prima = FASCE_UFFICIO[g][0];
    if (prima) {
      const quando = scarto === 1 ? 'domani' : NOMI_GIORNI[g];
      return { aperto: false, testo: `Chiuso, riapre ${quando} alle ${orario(prima[0])}` };
    }
  }
  return { aperto: false, testo: 'Chiuso' };
};
